<template>
  <div class="order-details pos-order-details">
    <!-- <div class="header acea-row row-middle">
      <div class="state">{{ title }}</div>
      <div class="data">
        <div class="order-num">订单：{{ orderInfo.order_id }}</div>
        <div>
          <span class="time">{{ orderInfo.add_time }}</span>
        </div>
      </div>
    </div> -->
    <!-- <div
      class="remarks acea-row row-between-wrapper"
      v-if="$route.params.goname != 'looks'"
    >
      <span class="iconfont icon-zhinengkefu-"></span>
      <input
        type="button"
        class="line1"
        style="text-align: left;"
        :value="
          orderInfo.remark ? orderInfo.remark : '订单未备注，点击添加备注信息'
        "
        @click="modify(1)"
      />
    </div> -->
    <div
      class="orderingUser acea-row row-middle"
      style="justify-content: space-between;"
    >
      <div style="color: #2a7efb;">
        <span class="iconfont icon-yonghu2" style="vertical-align: middle;">
          <!-- <img
          class="pic"
          src="https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQGN8TwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAyM2IzQ05DWE5jWm0xMDAwMDAwN3YAAgTnrjpjAwQAAAAA "
          alt=""
        />  --> </span
        >{{ list.nickname }}/{{ list.uid }}
      </div>
      <span class="copy copy-data" @click="onClick1">更换推荐人</span>
      <span class="copy copy-data" @click="onClick">转移其下属</span>
    </div>
    <div class="address">
      <div class="name">
        推荐人:{{ codeInfo.nickname }}({{ codeInfo.real_name || "未备注" }})/{{
          list.spread_uid
        }}
      </div>
      <div>关联时间:{{ list.spread_time1 }}</div>
    </div>
    <!-- <div class="line"><img src="@assets/images/line.jpg" /></div>
    <div class="pos-order-goods">
      <div
        class="goods acea-row row-between-wrapper"
        v-for="(item, index) in orderInfo._info"
        :key="index"
      >
        <div class="picTxt acea-row row-between-wrapper">
          <div class="pictrue">
            <img :src="item.cart_info.productInfo.image" />
          </div>
          <div class="text acea-row row-between row-column">
            <div class="info line2">
              {{ item.cart_info.productInfo.store_name }}
            </div>
            <div class="attr">{{ item.cart_info.productInfo.suk }}</div>
          </div>
        </div>
        <div class="money">
          <div class="x-money">￥{{ item.cart_info.productInfo.price }}</div>
          <div class="num">x{{ item.cart_info.cart_num }}</div>
          <div class="y-money">￥{{ item.cart_info.productInfo.ot_price }}</div>
        </div>
      </div>
    </div>
    <div class="public-total">
      共{{ orderInfo.total_num }}件商品，应支付
      <span class="money">￥{{ orderInfo.pay_price }}</span> ( 邮费 ¥{{
        orderInfo.pay_postage
      }}
      )
    </div> -->
    <div class="line"><img src="@assets/images/line.jpg" /></div>
    <div class="wrapper">
      <!-- <div class="item acea-row row-between">
        <div>昵称：</div>
        <div class="conter">{{ list.nickname }}</div>
      </div> -->

      <div class="item acea-row row-between">
        <div>姓名：</div>
        <input
          type="text"
          placeholder="未备注"
          v-model="list.real_name"
          class="mode"
        />
        <!-- <div class="conter">{{ list.real_name }}</div> -->
      </div>
      <div class="item acea-row row-between">
        <div>手机号：</div>
        <input
          type="text"
          placeholder="未备注"
          v-model="list.phone"
          class="mode"
        />
        <!-- <div class="conter">
          {{ list.phone }}
        </div> -->
      </div>
      <div class="item acea-row row-between">
        <div>医院科室：</div>
        <!-- <div class="conter">{{ list.mark }}</div> -->
        <input
          type="text"
          placeholder="未备注"
          v-model="list.markinfo"
          class="mode"
        />
      </div>
      <div class="item acea-row row-between" style="height: min-content;">
        <div style="padding-top: .3rem;">小程序推广码：</div>
        <!-- <div class="mode" @click="toDetail(item)" style="color:#2291f8">
          查看
        </div> -->
        <img
          class="pic"
          :src="'https://ztyy.online/' + codeInfo.code_src2"
          alt=""
          @click="getImg(codeInfo.code_src2)"
        />
      </div>
      <div class="item acea-row row-between" style="height: min-content;">
        <div style="padding-top: .3rem;">公众号推广码：</div>
        <!-- <div class="mode" @click="toDetail(item)" style="color:#2291f8">
          查看
        </div> -->
        <img
          class="pic"
          :src="codeInfo.code_src1"
          alt=""
          @click="getImg(codeInfo.code_src1)"
        />
      </div>
    </div>
    <!-- <div class="wrapper">
      <div class="item acea-row row-between">
        <div>公众号二维码：</div>
        <div class="conter">￥{{ orderInfo.total_price }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>优惠券抵扣：</div>
        <div class="conter">-￥{{ orderInfo.coupon_price }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>运费：</div>
        <div class="conter">￥{{ orderInfo.freight_price }}</div>
      </div>
      <div class="actualPay acea-row row-right">
        实付款：<span class="money font-color-red"
          >￥{{ orderInfo.pay_price }}</span
        >
      </div>
    </div> -->
    <!-- <div
      class="wrapper"
      v-if="
        orderInfo.delivery_type != 'fictitious' && orderInfo._status._type === 2
      "
    >
      <div class="item acea-row row-between">
        <div>配送方式：</div>
        <div class="conter" v-if="orderInfo.delivery_type === 'express'">
          快递
        </div>
        <div class="conter" v-if="orderInfo.delivery_type === 'send'">送货</div>
      </div>
      <div class="item acea-row row-between">
        <div v-if="orderInfo.delivery_type === 'express'">快递公司：</div>
        <div v-if="orderInfo.delivery_type === 'send'">送货人：</div>
        <div class="conter">{{ orderInfo.delivery_name }}</div>
      </div>
      <div class="item acea-row row-between">
        <div v-if="orderInfo.delivery_type === 'express'">快递单号：</div>
        <div v-if="orderInfo.delivery_type === 'send'">送货人电话：</div>
        <div class="conter">
          {{ orderInfo.delivery_id
          }}<span
            class="copy copy-data"
            :data-clipboard-text="orderInfo.delivery_id"
            >复制</span
          >
        </div>
      </div>
    </div> -->
    <div style="height:1.2rem;"></div>
    <div
      class="footer acea-row row-right row-middle"
      v-if="$route.params.goname != 'looks'"
    >
      <div class="more"></div>
      <!-- <div class="bnt cancel" @click="modify(0)" v-if="types == 0">
        一键改价
      </div>
      <div class="bnt cancel" @click="modify(0)" v-if="types == -1">
        立即退款
      </div> -->
      <!-- <div class="bnt cancel" @click="modify(1)">订单备注</div> -->
      <div class="bnt delivery" @click="saveInfo">
        确认保存
      </div>
      <!-- <router-link
        class="bnt delivery"
        v-if="types == 1"
        :to="'/customer/delivery/' + orderInfo.order_id"
        >去发货</router-link
      > -->
    </div>
    <!-- <PriceChange
      :change="change"
      :orderInfo="orderInfo"
      v-on:closechange="changeclose($event)"
      v-on:savePrice="savePrice"
      :status="status"
    ></PriceChange> -->

    <van-dialog
      v-model="show"
      title="转移其下属所有成员"
      show-cancel-button
      :beforeClose="chargeBtn"
      @confirm="handleConfirm"
    >
      <!--输入框-->
      <van-form ref="form">
        <van-field
          v-model="message"
          rows="1"
          name="uid"
          autosize
          required
          label="转移至"
          type="tel"
          placeholder="请输入uid"
          :rules="[{ pattern: /^\d{1,7}$/, message: '请输入正确uid' }]"
        />
      </van-form>
    </van-dialog>

    <van-dialog
      v-model="show1"
      title="更换推荐人"
      show-cancel-button
      :beforeClose="chargeBtn1"
      @confirm="handleConfirm1"
    >
      <!--输入框-->
      <van-form ref="form1">
        <van-field
          v-model="message1"
          rows="1"
          name="uid"
          autosize
          required
          label="更换为"
          type="tel"
          placeholder="请输入uid"
          :rules="[{ pattern: /^\d{1,7}$/, message: '请输入正确uid' }]"
        />
      </van-form>
    </van-dialog>
  </div>
</template>
<script>
// import PriceChange from "@components/PriceChange";
import ClipboardJS from "clipboard";
// import Vue from "vue";

import { ImagePreview, Dialog as ty, Field, Form } from "vant";
import {
  setSpreadInfo,
  getSpreadCode,
  transSpread,
  changeSpread
} from "../../api/admin";
import attrs, { chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";

// Vue.use(Dialog);
// Vue.use(Field);
export default {
  name: "SpreadDetail",
  components: {
    [Field.name]: Field,
    [ty.Component.name]: ty.Component,
    [Form.name]: Form
  },
  props: {},
  data: function() {
    return {
      images: [],
      order: false,
      change: false,
      show: false,
      show1: false,
      order_id: "",
      uid: "",
      codeInfo: {},
      list: {},
      status: "",
      title: "",
      payType: "",
      message: "",
      message1: "",
      types: ""
    };
  },
  watch: {
    "$route.params.list": function(newVal) {
      let that = this;
      console.log("nishi ", newVal);
      if (newVal != undefined) {
        that.list = newVal;
        that.getIndex();
      }
    }
  },
  mounted: function() {
    this.list = JSON.parse(this.$route.params.list);
    this.getIndex();
    this.$nextTick(function() {
      var copybtn = document.getElementsByClassName("copy-data");
      const clipboard = new ClipboardJS(copybtn);
      clipboard.on("success", () => {
        this.$dialogP.success("复制成功");
      });
    });
  },
  methods: {
    onClick: function() {
      this.show = true;
    },
    onClick1: function() {
      this.show1 = true;
    },
    chargeBtn(action, done) {
      //确认or取消
      if (action === "cancel") {
        //取消按钮
        this.$refs["form"].resetValidation("uid");
        this.$nextTick(() => {
          this.$refs["form"].resetFields();
        });
        // this.uid = undefined;
        done();
      } else if (action === "confirm") {
        //确定按钮
        //向后端传值并关闭dialog弹出框
        // this.show = false;
        done(false);
      }
    },
    chargeBtn1(action, done) {
      //确认or取消
      if (action === "cancel") {
        //取消按钮
        console.log("44444444", this.$refs);
        this.$refs["form1"].resetValidation("uid");
        this.$nextTick(() => {
          this.$refs["form"].resetFields();
        });
        // this.uid = undefined;
        done();
      } else if (action === "confirm") {
        //确定按钮
        //向后端传值并关闭dialog弹出框
        // this.show = false;
        done(false);
      }
    },

    handleConfirm() {
      let that = this;
      this.$refs["form"]
        .validate()
        .then(() => {
          transSpread(that.list.uid, that.message).then(
            res => {
              that.message = "";

              that.show = false; // 在这里手动的关闭弹窗
              // that.$toast.success("新增成功");
              that.$dialogP.success(res.msg);
              console.log("women", that.message);
              // this.name = undefined;
              // this.onRefresh();
            },
            err => {
              that.message = "";

              that.show = false;
              that.$dialogP.error(err.msg);
            }
          );
        })
        .catch(() => {});
    },

    handleConfirm1() {
      let that = this;
      this.$refs["form1"]
        .validate()
        .then(() => {
          changeSpread(that.list.uid, that.message1).then(
            res => {
              that.message1 = "";

              that.show1 = false; // 在这里手动的关闭弹窗
              // that.$toast.success("新增成功");
              that.$dialogP.success(res.msg);
              // console.log("women", that.message);
              // this.name = undefined;
              // this.onRefresh();
            },
            err => {
              that.message1 = "";

              that.show1 = false;
              that.$dialogP.error(err.msg);
            }
          );
        })
        .catch(() => {});
    },

    more: function() {
      this.order = !this.order;
    },
    modify: function(status) {
      this.change = true;
      this.status = status;
    },
    changeclose: function(msg) {
      this.change = msg;
    },
    getIndex: function() {
      let that = this;
      getSpreadCode(that.list.uid, that.list.spread_uid).then(
        res => {
          that.codeInfo = res.data;
          console.log("womeeeeeen", that.list.spread_uid);

          // that.types = res.data._status._type;
          // that.title = res.data._status._title;
          // that.payType = res.data._status._payType;
        },
        err => {
          that.$dialogP.error(err.msg);
        }
      );
    },
    async saveInfo() {
      let that = this,
        data = {},
        real_name = that.list.real_name,
        phone = that.list.phone;
      data.mark = that.list.markinfo;
      try {
        await this.$validator({
          real_name: [attrs.range([2, 16], attrs.range.message("姓名"))],
          phone: [chs_phone(chs_phone.message())]
        }).validate({ real_name, phone });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      data.real_name = real_name;
      data.phone = phone;
      setSpreadInfo(data, that.list.uid).then(
        res => {
          // that.change = false;
          that.$dialogP.success(res.msg);
          // that.getIndex();
        },
        err => {
          // that.change = false;
          that.$dialogP.error(err.msg);
        }
      );
    },

    getImg(image) {
      let that = this;
      that.images = [];
      that.images.push(image);
      ImagePreview({
        images: that.images, // 预览图片的那个数组
        closeable: true,
        loop: false
        // startPosition: index // 指明预览第几张图
      });
    }
  }
};
</script>
<style scoped>
.wrapper {
  margin-top: auto;
  padding: 0 !important;
}
.item {
  border-bottom: 1px solid #f0f0f0;
  padding: 0.3rem;
  height: 0.8rem;
  font-size: 0.32rem;
  color: #282828;
  position: relative;
}
.mode {
  /* width: 4.6rem;
  height: 100%; */
  text-align: right;
}
.pic {
  width: 1.3rem;
  height: 1.3rem;

  border-radius: 0.06rem;
}

.copy {
  font-size: 0.22rem;
  color: #fc4141;
  border-radius: 0.03rem;
  border: 1px solid #fc4141;
  padding: 0.03rem 0.15rem;
  /* margin-left: 3.3rem; */
}
</style>
